import React, { Component } from "react";
import Button from "./Button";

class Jumboend extends Component {
  v;
  render() {
    const jumbotronStyle = {
      paddingTop: "100px",
      paddingBottom: "100px",
      textAlign: "center"
    };

    const quoteFinal =
      "Prêt à effectuer votre virage numérique avec Prospection?";
    return (
      <section className="container" style={jumbotronStyle}>
        <div className="row justify-content-around align-items-center">
          <div className="col-12">
            <p className="h3">{quoteFinal}</p>
          </div>
          <div className="col-12 d-flex justify-content-center align-items-center">
            <Button text={"Contactez-nous"} />
          </div>
        </div>
      </section>
    );
  }
}

export default Jumboend;
